<app-section-outline-block
  [className]="sectionClassName + ' ' + layoutClass"
  [isShowFloatingTitle]="isShowFloatingTitle"
  [floatingTitle]="floatingTitle"
  floatingTitleIcon="assets/images/document-upload-circled.svg"
  [isShowHeaderBorder]="isShowHeaderBorder"
  [headerTitle]="headerTitle"
  [theme]="theme"
>
  <ng-container section-header>
    <div
      *ngIf="!!index && isShowDeleteBlButton"
      nz-tooltip
      nzTooltipColor="#ffffff"
      nzTooltipPlacement="top"
      nzTooltipOverlayClassName="normalize"
      [nzTooltipTitle]="'BUTTON.DELETE' | translate"
      class="app-es-documents-bl-box__delete-button"
      (click)="onDeleteBl(shipment?.id)"
    >
      <img src="assets/icons/icon_trash.svg" alt="delete" />
    </div>

    <app-notification-box
      *ngIf="isShowMultipleBlsHint"
      iconImage="/assets/icons/icon_attention_sm.svg"
      headerTitle="LABELS.PAY_ATTENTION"
      description="ENTRY_SUMMARY.BILL_OF_LADING_DOCS.HINT"
    ></app-notification-box>
  </ng-container>

  <ng-container section-header-actions>
    <div class="app-es-documents-bl-box__header__actions-group">
      <button
        class="app-es-documents-bl-box__header__actions__download-all-files-btn btn btn-link d-block"
        type="button"
        *ngIf="isShowDownloadAllDocs"
        (click)="onDownloadAllFiles()"
      >
        <img src="assets/icons/icon_download_sm_blue.svg" alt="download" />
        <span>
          {{ "LABELS.DOWNLOAD_ALL_FILES" | translate }}
        </span>
      </button>

      <div
        class="btn-group app-es-documents-bl-box__header__actions__add-documents d-print-none"
        dropdown
        *ngIf="additionalDocumentsOptions.length > 0"
      >
        <button id="button-files" dropdownToggle type="button" class="btn btn-link dropdown-toggle">
          <span class="wrapper-icon-add"><i class="fa fa-plus"></i></span>
          <span>{{ "BUTTON.ADD_OTHER_DOCUMENT" | translate }}</span>
          <span class="wrapper-icon-carret"><i class="fa fa-chevron-down"></i></span>
        </button>
        <ul id="dropdown-files" class="dropdown-menu" role="menu" *dropdownMenu>
          <li role="menuitem" *ngFor="let doc of additionalDocumentsOptions" (click)="onAddOtherDocument(doc, shipment?.id)">
            <span class="dropdown-item">
              {{ "ENTRY_SUMMARY.BILL_OF_LADING_DOCS." + enumDocumentType[doc] + ".TITLE" | translate }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>

  <ng-container *ngFor="let doc of entryDocuments">
    <document-upload-desktop
      [id]="'es-doc-' + shipment?.id + '-' + doc.type + '-' + doc.id"
      [uploadedDocument]="document(doc, shipment?.id)"
      [attachmentName]="documentName(doc, index + 1)"
      [attachmentHint]="documentHint(doc.type)"
      [isAttachmentHintHtml]="doc.type === enumDocumentType.ARRIVAL_NOTICE"
      [isLoading]="!!isLoadingDocUploadFlags && isLoadingDocUploadFlags.get(doc.type + '-' + shipment?.id + '-' + doc.id)"
      [isShowLoader]="!isLoadingDocUploadFlags"
      [isSimpleStripLayout]="true"
      [isFullErrorHighlight]="true"
      [isShowDeferredRequiredTag]="isShowDeferredRequiredTag(doc.type)"
      [requiredLaterTooltip]="
        isShowDeferredRequiredTag(doc.type) ? 'ENTRY_SUMMARY.BILL_OF_LADING_DOCS.ARRIVAL_NOTICE.REQUIRED_LATER_TOOLTIP' : null
      "
      [isShowOptionalTag]="isShowOptionalTag(doc.type)"
      [isHideTag]="true"
      [isRequired]="isRequired(doc.type)"
      [canRemoveDocuments]="isShowDocRemove"
      [canViewDocuments]="isShowDocPreview"
      [canDownloadDocuments]="isShowDocDownload"
      [canUploadDocuments]="true"
      [isShowLabelOverUploadedDate]="isShowLabelOverUploadedDate"
      (upload)="onUploadDocument($event, doc, shipment?.id)"
      (preview)="onPreviewDocument($event)"
      (remove)="onDeleteDocument($event, shipment?.id)"
      (stateUpdate)="onUpdateDocumentState($event, doc, shipment?.id)"
      (inputClick)="onInputClick()"
    ></document-upload-desktop>
  </ng-container>

  <ng-container *ngFor="let doc of visibleLocalAdditionalDocuments">
    <document-upload-desktop
      [id]="'es-doc-additional-' + shipment?.id + '-' + doc.type + '-' + doc.id"
      [uploadedDocument]="doc"
      [attachmentName]="additionalDocumentName(doc)"
      [attachmentHint]="documentHint(doc.type)"
      [isAttachmentHintHtml]="doc.type === enumDocumentType.ARRIVAL_NOTICE"
      [isSimpleStripLayout]="true"
      [isFullErrorHighlight]="true"
      [isHideTag]="true"
      [isRequired]="false"
      [canRemoveDocuments]="true"
      [canUploadDocuments]="true"
      [isShowLabelOverUploadedDate]="isShowLabelOverUploadedDate"
      (upload)="onUploadAdditionalDocument($event, doc, shipment?.id)"
      (remove)="onRemoveAdditionalSlot(doc)"
      (inputClick)="onInputClick()"
    ></document-upload-desktop>
  </ng-container>

  <div *ngIf="isShowSkipOcrScanControl" section-footer class="custom-control custom-checkbox pl-4 pt-2">
    <input type="checkbox" [formControl]="skipOcrScanControl" class="custom-control-input" [id]="'skipOCRCheckbox-' + index" />
    <label class="custom-control-label" [for]="'skipOCRCheckbox-' + index">
      {{ "UPLOAD_ENTRY_DOCS_WITHOUT_SCANNING" | translate }}
    </label>
  </div>
</app-section-outline-block>
